module.exports = __webpack_public_path__ + "static/img/img2.c1bfc401.png";